import React from 'react';
import { Sparkles, ListChecks, Users } from 'lucide-react';

export default function AISummary({ summary }) {
  if (!summary) return null;

  return (
    <div className="summary-block" data-testid="thread-ai-summary">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-7 h-7 rounded-lg bg-[hsl(var(--summary-foreground))]/10 flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-[hsl(var(--summary-foreground))]" />
        </div>
        <h3 className="font-heading font-semibold text-sm">Résumé du thread</h3>
        {summary.consensus && (
          <span className="text-xs px-2 py-0.5 rounded-full bg-[hsl(var(--summary-foreground))]/10">
            {summary.consensus === 'accord' ? 'Consensus' : summary.consensus === 'desaccord' ? 'Désaccord' : 'Nuancé'}
          </span>
        )}
      </div>

      <p className="text-sm leading-relaxed mb-3">{summary.summary}</p>

      {summary.key_points && summary.key_points.length > 0 && (
        <div className="mb-2">
          <div className="flex items-center gap-1.5 mb-1">
            <ListChecks className="w-3.5 h-3.5" />
            <span className="text-xs font-semibold">Points clés</span>
          </div>
          <ul className="space-y-1">
            {summary.key_points.map((point, i) => (
              <li key={i} className="text-xs leading-relaxed flex gap-2">
                <span className="text-[hsl(var(--summary-foreground))]/60 shrink-0">•</span>
                {point}
              </li>
            ))}
          </ul>
        </div>
      )}

      {summary.topics && summary.topics.length > 0 && (
        <div className="flex items-center gap-2 flex-wrap mt-2">
          {summary.topics.map((topic, i) => (
            <span key={i} className="text-[10px] px-2 py-0.5 rounded-full bg-[hsl(var(--summary-foreground))]/10">
              {topic}
            </span>
          ))}
        </div>
      )}

      <p className="text-[10px] text-[hsl(var(--summary-foreground))]/50 mt-2">
        Généré par IA • {summary.comment_count || 0} commentaires analysés
      </p>
    </div>
  );
}
